import { render, staticRenderFns } from "./infancy.vue?vue&type=template&id=4c44e3ab&scoped=true"
import script from "./infancy.vue?vue&type=script&lang=js"
export * from "./infancy.vue?vue&type=script&lang=js"
import style0 from "./infancy.vue?vue&type=style&index=0&id=4c44e3ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c44e3ab",
  null
  
)

export default component.exports